/* global API */

import each from '../helpers/each';
import formatPrice from '../helpers/formatPrice';

const $addProductModal = $('.js-add-product-modal');
const $changeTable = $('.js-change-table');

const addProductModal = {
  /**
   * Initialize add product modal
   * @return {void}
   */
  initialize() {
    if ($addProductModal.length) {
      this.template = $('#order-item-template').html();
      this.createListeners();
    }
  },

  /**
   * Create event listeners
   * @return {void}
   */
  createListeners() {
    $addProductModal.on('submit', '.js-single-product-form', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const formElement = e.currentTarget;
      const inputElement = formElement.querySelector('[name="quantity"]');
      const productIdElement = formElement.querySelector('[name="product_variant_id"]');

      const productId = productIdElement.value;
      const quantity = parseInt(inputElement.value, 10);
      const minimumQuantity = inputElement ? parseInt(inputElement.getAttribute('min'), 10) : 1;

      this.addProduct(productId, quantity, minimumQuantity);
      this.closeModal();
    });
  },

  addProduct(productId, quantity, minimumQuantity) {
    $.ajax({
      url: `${API.product}/${productId}`,
      success: (res) => {
        const totalPrice = res.price_with_tax * quantity;

        const productInformation = Object.assign(res, {
          quantity,
          total_price_with_tax: totalPrice,
          total_price_with_tax_formatted: formatPrice(totalPrice),
        });

        this.addRowToOrder(productInformation, minimumQuantity);
      },
    });
  },

  closeModal() {
    $addProductModal.modal('hide');
  },

  addRowToOrder(productInformation, minimumQuantity = 1) {
    const $existingRowInput = $changeTable.find(`[name="products[${productInformation.id}]"]`);

    // If there's already a row with the product id
    if ($existingRowInput.length) {
      const quantity = parseInt($existingRowInput.val(), 10);

      // Trigger change on the table to recalculate totals
      $(document).trigger('change:quantity', $existingRowInput.next());

      // Change amount of the product
      $existingRowInput.val(quantity + productInformation.quantity).trigger('change');

      // Trigger change on the table to recalculate totals
      $changeTable.trigger('recalculate');

      return;
    }

    let itemHTML = this.template;

    each(productInformation, (val, key) => {
      itemHTML = itemHTML.replace(new RegExp(`## ${key} ##`, 'g'), val);
    });

    const $itemHTML = $(itemHTML);

    $itemHTML.find('.js-change-quantity').attr('min', minimumQuantity);

    $changeTable
      .append($itemHTML)
      .trigger('recalculate');
  },
};

export default addProductModal;
